import { render, staticRenderFns } from "./InsurancePlanTable.vue?vue&type=template&id=743dc8b4&"
import script from "./InsurancePlanTable.vue?vue&type=script&lang=js&"
export * from "./InsurancePlanTable.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePlanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VDataTable,VLayout,VSelect,VTextField})
